import { render, staticRenderFns } from "./default.vue?vue&type=template&id=fb0c8cc6&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=fb0c8cc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../MultiSiteClient/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0c8cc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../MultiSiteClient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
